const faqs = [
  {
    q: '女神漫画下拉式是什么意思？和普通翻页有什么区别？',
    a: '女神漫画下拉式是一种专为手机优化的阅读模式。与传统的左右翻页不同，下拉式将所有漫画画面排列在一个连续的垂直页面中，你只需要向下滚动屏幕就能连续阅读整话乃至全集内容。这种方式更适合手机单手操作，不用频繁点击翻页按钮，沉浸感更强，是女神漫画网的核心特色。',
  },
  {
    q: '女神漫画网的内容是免费的吗？需要注册吗？',
    a: '女神漫画下拉式平台上的所有漫画均为免费全集阅读，无需注册或登录。我们致力于为漫画爱好者提供零门槛的阅读体验，从韩漫恋爱甜文到日漫热血战斗，所有作品都可以直接打开下拉式页面畅读，没有任何隐藏收费或会员限制。',
  },
  {
    q: '女神漫画下拉式支持哪些设备？手机看效果好吗？',
    a: '女神漫画下拉式阅读专为移动端深度优化，支持 iOS 和 Android 所有主流手机浏览器。图片自适应屏幕宽度，加载速度快，触控滚动流畅。同时也兼容平板和桌面端浏览器，在电脑上阅读时可以使用鼠标滚轮实现同样的下拉式连续阅读体验。',
  },
  {
    q: '漫画更新频率怎么样？新番什么时候上？',
    a: '女神漫画网保持每日更新节奏，韩漫和日漫热门作品与官方同步更新。新番上线后我们会第一时间提供下拉式版本。您可以通过首页的"最新动态"模块查看每日更新列表，也可以关注"热门榜单"了解当前最受欢迎的作品和最新上架信息。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">常见问题</h2>
          <p className="text-sm text-foreground-500 mt-2">关于女神漫画下拉式的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden">
              <div className="p-5">
                <div className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 text-xs font-heading mt-0.5">
                    Q
                  </span>
                  <div>
                    <h3 className="text-sm font-medium text-foreground-800 mb-2">{faq.q}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}